    <template>
    <div class="event-list">
      <div id="ag-table" class="dataTables_wrapper dt-bootstrap4 no-footer">
        <div class="table-responsive">
          <ag-loading v-if="table.isLoading" />
          <TableLite
            v-show="!table.isLoading"
            class="table table-hover"
            :has-checkbox="false"
            :is-loading="table.isLoading"
            :columns="table.columns"
            :rows="table.rows"
            :total="table.totalRecordCount"
            @do-search="getList"
            @is-finished="tableLoadingFinish"
          />
        </div>
      </div>
    </div>
  </template>

  <script>
  import { useStore } from "@/store";
  import api from "@/store/axiosAgsc";
  import moment from "moment";
  import TableLite from "vue3-table-lite";
  import { useI18n } from "vue-i18n";
  import { reactive, ref } from "vue";
  import { GeneralActionTypes } from "@/store/modules/general/action-types";
  import AgLoading from "@/components/ag-loading/index.vue";
  import { useCommonStore } from "@/stores/common";
  import { mapStores } from "pinia";
  import dateOptions from "@/helpers/DateOptions";

  const store = useStore();
  let hash = "";
  export default {
    name: "ag-event-list",
    props: {
      props: {
        data: {
          type: Array,
          default: null,
        },
        options: {
          type: Object,
          default: null,
        },
      },
    },
    components: {
      TableLite,
      AgLoading,
    },
    data() {
      return {
        activeStatus: "",
      };
    },
    setup() {
      const checkedRows = ref([]);
      const i18n = useI18n();
      const strLen = 20;

      const table = reactive({
        isLoading: false,
        columns: [
          {
            label: "Actor",
            field: "actor",
            display: function (row) {
              const fullStr = row.actor;
              let data = fullStr;
              if (!fullStr) {
                return "";
              }
              if (fullStr.length > strLen) {
                data =
                  fullStr.substr(0, 10) +
                  "..." +
                  fullStr.substr(fullStr.length - 10);
              }
              return `<span class="ag-tooltip">${data}<div class="right">${row.actor}<i></i></div></span>`;
            },
          },
          {
            label: "Policy Version",
            field: "policy",
            sortable: false,
            display: function (row) {
              return row.policy / 10;
            },
          },
          {
            label: "Event Type",
            field: "eventType",
            sortable: false,
          },
          {
            label: "Severity",
            field: "severity",
            display: function (row) {
              let type = "";
              switch (row.severity) {
                case "Default":
                  type = "level_one";
                  break;
                case "Low":
                  type = "level_two";
                  break;
                case "Medium":
                  type = "level_three";
                  break;
                case "High":
                  type = "level_four";
                  break;
                case "Critical":
                  type = "level_five";
                  break;
              }
              return (
                '<span class="pt-1 pb-1 pr-2 pl-2 ag-label text-white small ag-background_' +
                type +
                '">' +
                row.severity +
                "</span>"
              );
            },
            sortable: false,
          },
          {
            label: "Computer",
            field: "computerName",
            sortable: false,
            display: function (row) {
              const fullStr = row.computerName;
              let data = fullStr;
              if (!fullStr) {
                return "";
              }
              if (fullStr.length > strLen) {
                data =
                  fullStr.substr(0, 10) +
                  "..." +
                  fullStr.substr(fullStr.length - 10);
              }
              return `<span class="ag-tooltip">${data}<div class="right">${row.computerName}<i></i></div></span>`;
            },
          },
          {
            label: "Seen",
            field: "lastSeen",
            sortable: false,
            display: function (row) {
              return `<div style="display: flex; flex-direction: column">
                <span>${moment(row.lastSeen).format("L")}</span>
                <span>${moment(row.lastSeen).format("hh:mm:ss A")}</span>
              </div>`;
            },
          },
          {
            label: "",
            field: "view",
            sortable: false,
            display: function (row, t) {
              return `<a href="javascript: void(0);" data-id="${row.id}" data-hash="${row.hash}" class="name-btn openDetail"><i class="ag-icon ag-icon_expand"></i> Details</a>`;
            },
          },
        ],
        sortable: {
          order: "name",
          sort: "asc",
        },
      });

    const tableLoadingFinish = () => {
    let detailElements = document.querySelectorAll(".openDetail");
    Array.prototype.forEach.call(detailElements, function (element) {
      if (element.classList.contains("openDetail")) {
        element.addEventListener("click", function () {
          let id = element.getAttribute("data-id");
          const hash = element.getAttribute("data-hash");
          api.get("Event/GetEventDetail?eventId=" + id).then((res) => {
            let row = res.data.entityData;
            row.evenId = id;
            row.uniqueEventHash = hash;
            row.computerGuid = row.ComputerId;
            if (
              res &&
              res.data &&
              res.data.entityData &&
              res.data.entityData.EventDetails &&
              res.data.entityData.EventDetails._t
            ) {
              row.eventTypeName = res.data.entityData.EventDetails._t;
              row.operationType = res.data.entityData.EventDetails.OperationType;
            } else {
              console.log("error", "event details not found");
            }
            row.hash = hash;
            
            if (!row.groupGuid && store.state.general.selectedExpandedRow) {
              row.groupGuid = store.state.general.selectedExpandedRow.groupGuid;
              row.ruleId = store.state.general.selectedExpandedRow.ruleId;
              row.ruleSource = store.state.general.selectedExpandedRow.ruleSource;
              row.ruleName = store.state.general.selectedExpandedRow.ruleName;
              row.target = store.state.general.selectedExpandedRow.target;
            }

            store.dispatch(GeneralActionTypes.SET_SELECTED_ROW, row);
            if (document.getElementById("ag-tab_overallview")) {
              document.getElementById("ag-tab_overallview").style.display =
              "block";
            }
            if (document.getElementById("ag-tab_processtree")) {
              document.getElementById("ag-tab_processtree").style.display =
              "block";
            }
            if (document.getElementById("ag-tab_computer")) {
              document.getElementById("ag-tab_computer").style.display =
              "block";
            }
            if (document.getElementById("ag-tab_hashdetails")) {
              document.getElementById("ag-tab_hashdetails").style.display =
              "block";
            }
            if (document.getElementById("ag-tab_hashxmldetail")) {
              document.getElementById("ag-tab_hashxmldetail").style.display =
              "block";
            }
            if (document.getElementById("ag-tab_policy")) {
              document.getElementById("ag-tab_policy").style.display = "block";
            }
            
            document.getElementById("ag-tab_hashxmldetail").click();
          });
        });
      }
    });
  };

      return {
        table,
        tableLoadingFinish,
        checkedRows,
      };
    },
    computed: {
      ...mapStores(useCommonStore),
      selectedRow() {
        return store.state.general.selectedExpandedRow;
      },
      compKey() {
        return store.getters.compKey;
      },
    },
    watch: {
      selectedRow() {
        this.getList(0, 10);
      },
      compKey() {
        this.hideTabs();
      },
    },
    async mounted() {
      this.hideTabs();
      await this.getList(0, 10);
    },
    methods: {
      hideTabs() {
        try {
          if (document.getElementById("ag-tab_overallview")) {
            document.getElementById("ag-tab_overallview").style.display = "none";
          }
          if (document.getElementById("ag-tab_processtree")) {
            document.getElementById("ag-tab_processtree").style.display = "none";
          }
          if (document.getElementById("ag-tab_computer")) {
            document.getElementById("ag-tab_computer").style.display = "none";
          }
          if (document.getElementById("ag-tab_hashdetails")) {
            document.getElementById("ag-tab_hashdetails").style.display = "none";
          }
          if (document.getElementById("ag-tab_hashxmldetail")) {
            document.getElementById("ag-tab_hashxmldetail").style.display =
              "none";
          }
          if (document.getElementById("ag-tab_policy")) {
                  document.getElementById("ag-tab_policy").style.display ="none";
          }
        } catch (e) {
          console.log(e);
        }
      },
      async getList(offset, limit) {
        if (!this.selectedRow.decisionId) {
          this.table.columns.shift();
        }

        let date = dateOptions.find((i) => i.label === "Last 7 days");
        let startPolicyFileVersion = "";
        let endPolicyFileVersion = "";
        if (this.commonStore.policyFilter.type === "default") {
          if (
            this.commonStore.policyFilter.data.startVersion &&
            this.commonStore.policyFilter.data.startVersion.value
          ) {
            startPolicyFileVersion =
              this.commonStore.policyFilter.data.startVersion.value;
          }
          if (
            this.commonStore.policyFilter.data.endVersion &&
            this.commonStore.policyFilter.data.endVersion.value
          ) {
            endPolicyFileVersion =
              this.commonStore.policyFilter.data.endVersion.value;
          }
        }

        if (this.commonStore.dropdownDate) {
          date = dateOptions.find(
            (i) => i.label === this.commonStore.dropdownDate
          );
        }

        if (!this.selectedRow.uniqueEventHash) {
          return;
        }
        
        const data = {
          page: offset / limit,
          limit: limit,
          terms: [],
          fields: [],
          eventTypeKeyword: this.selectedRow.eventTypeName,
          severity: "",
          facility: null,
          os: null,
          code: null,
          commandLine: "",
          startPolicyFileVersion: startPolicyFileVersion,
          endPolicyFileVersion: endPolicyFileVersion,
          eventCount: null,
          membershipType: "",
          type: "",
          agentVersion: "",
          _source: true,
          user: "",
          GroupIds: store.getters.group.key,
          agscEventType: "",
          sortColumn: "",
          sortDir: "asc",
          startDate: date.value,
          endDate: moment().utc(),
          hash: this.selectedRow.uniqueEventHash,
          operationType: this.selectedRow.operationType,
        };

        this.table.isLoading = true;
        data.page += 1;
        const res = await api.post(
          "PolicyReview/IndividualProposedUniqueBlocks",
          data
        );
        this.table.rows = res.data.entityData ? res.data.entityData : [];
        hash = this.selectedRow.uniqueEventHash;
        this.table.totalRecordCount = res.data.totalCount;
        this.table.isLoading = false;
      },
    },
  };
  </script>

  <style lang="scss">
  .event-list {
    font-size: 15px;
  }

  .event-list .table-responsive > .card {
    padding: 0;
  }

  .event-list .table-responsive select {
    margin: 0 7.5px;
  }

  .event-list .table-responsive div[role="status"] {
    font-size: 13px;
  }

  .event-list
    .table-responsive
    .pagination
    .page-item.disabled:not(:nth-child(1)):not(:nth-child(2)):not(:nth-last-child(1)):not(:nth-last-child(2))
    a {
    background: #4c8dbb;
    color: #fff !important;
  }

  .event-list .table-responsive .pagination .page-item.disabled a:focus,
  .event-list .table-responsive .pagination .page-item.disabled a:hover {
    box-shadow: none !important;
    outline: none !important;
  }
  .name-btn {
    display: flex;
    align-items: center;
    i {
      margin-right: 4px;
    }
  }
  </style>
  